import styled from 'styled-components';
import { smRegular } from '../theme/typography';
import { themeColor } from '../theme/colors';
import { ellipsisMixin } from '../theme/utils';

export const Container = styled.div`
  ${ellipsisMixin};
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const Label = styled.span<{ $hidden?: boolean }>`
  ${smRegular};
  color: ${themeColor('textPrimary')};
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
`;

export const Text = styled.span`
  ${smRegular};
  ${ellipsisMixin};
  color: ${themeColor('textSecondary')};
`;
